import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from 'react';
import { memo, useMemo } from 'react';
import get_axis from 'console/tabs/graphs/components/graph/utils/axes';
import { RFIndicators } from 'console/react-elements/rf-indicators';
import * as classnames from 'classnames';
import './_thermometers-view.sass';
import { Box, Typography } from '@mui/material';
import { useHelpPopup } from 'shared/hooks/ui/help-popup';
import { ThermometerState } from 'webui/utils/thermometers';
const temperature_axis = get_axis('temperature');
function ThermometerImpl(props) {
    const { state, value, rf, name, axis_key, color, micro, limits } = props;
    const value_text = useMemo(() => {
        switch (state) {
            case ThermometerState.not_connected:
                return 'не подключен';
            case ThermometerState.malfunction:
                return 'недоступен';
            case ThermometerState.ok:
                if (value != null) {
                    const axis = axis_key != null
                        ? get_axis(axis_key) ?? temperature_axis
                        : temperature_axis;
                    return axis.format_value_with_unit(value);
                }
                return '--';
            default:
                return '--';
        }
    }, [state, value, axis_key]);
    const long_text = useMemo(() => [ThermometerState.not_connected, ThermometerState.malfunction].includes(state), [state]);
    const fail = useMemo(() => (limits?.high != null && value != null && value > limits.high) ||
        (limits?.low != null && value != null && value < limits.low), [limits, value]);
    const [HelpPopup, open] = useHelpPopup();
    return (_jsxs(_Fragment, { children: [_jsxs("div", { className: classnames('ui-thermometers-view-therm', {
                    'ui-thermometer-view-fail': fail,
                }), onClick: open, children: [_jsxs("div", { className: classnames('ui-thermometers-view-therm-title', {
                            micro: micro,
                        }), children: [rf != null && (_jsx("div", { className: "ui-thermometers-view-therm-icons", children: _jsx(RFIndicators, { rf: rf }) })), _jsx("div", { className: "ui-thermometers-view-therm-title-text", children: name })] }), _jsx("div", { className: classnames('ui-thermometers-view-therm-value', {
                            'ui-thermometers-view-therm-value-long': long_text,
                            micro: micro,
                        }), style: { borderColor: color }, children: value_text })] }), _jsx(HelpPopup, { children: _jsxs(Box, { display: "flex", flexDirection: "column", alignItems: "center", children: [_jsx(Typography, { variant: "h6", children: name }), _jsx(RFIndicators, { rf: rf, show_values: true }), _jsx(Typography, { variant: "subtitle1", children: value_text }), limits?.low && value ? (_jsxs(Typography, { variant: "subtitle2", color: value < limits.low ? 'error' : 'textSecondary', children: ["\u041D\u0438\u0436\u043D\u0438\u0439 \u043F\u0440\u0435\u0434\u0435\u043B\u00A0", limits.low] })) : null, limits?.high && value ? (_jsxs(Typography, { variant: "subtitle2", color: value > limits.high ? 'error' : 'textSecondary', children: ["\u0412\u0435\u0440\u0445\u043D\u0438\u0439 \u043F\u0440\u0435\u0434\u0435\u043B\u00A0", limits.high] })) : null] }) })] }));
}
export const Thermometer = memo(ThermometerImpl);
